export default __webpack_public_path__ + "static/media/backgroundcard.08a55777.png";